
export const FirstPageGone={
    // "Super Admin":"/PAG/customer/dashboard",
    "Super Admin":"/mpim/Dashboard",
    // Administrator:"/PAG/customer/dashboard",
    Administrator:"/mpim/Dashboard",
    "GC Login True":"/PAG/Mop/database",
    "GC Login False":"/PAG/ran/support/dashboard",
    FOPS:"/PAG/Mop/database",
    Development:"/PAG/Mop/database",
    "RF Engineer":"/PAG/Mop/database",
    // "Manage Engineer":"/PAG/customer/dashboard"
    "Manage Engineer":"/mpim/Dashboard"
}


export function funct(chartTable1 = []) {
    let data1 = [];
  
    let header1 = [];
    let column1 = [];
    let open1 = [];
    let close1 = [];
    chartTable1.map((itm) => {
      // console.log(itm,"djsd")
      let dataing = [];
      header1.push(itm["_id"]["vendor"]);
      dataing.push(itm["_id"]["vendor"]);
      if (itm["data"].length == 2) {
        if (itm["data"][0]["status"] == "Open") {
          dataing.push(itm["data"][0]["count"] + itm["data"][1]["count"]);
          dataing.push(itm["data"][0]["count"]);
          dataing.push(itm["data"][1]["count"]);
        }
        if (itm["data"][1]["status"] == "Open") {
          dataing.push(itm["data"][0]["count"] + itm["data"][1]["count"]);
          dataing.push(itm["data"][1]["count"]);
          dataing.push(itm["data"][0]["count"]);
        }
      }
      if (itm["data"].length == 1) {
        if (itm["data"][0]["status"] == "Open") {
          dataing.push(itm["data"][0]["count"]);
          dataing.push(itm["data"][0]["count"]);
          dataing.push(0);
        }
        if (itm["data"][0]["status"] == "Close") {
          dataing.push(itm["data"][0]["count"]);
          dataing.push(0);
          dataing.push(itm["data"][0]["count"]);
        }
      }
  
      data1.push(dataing);
      console.log(data1, "lksjadksa");
      column1.push(itm["_id"]["vendor"]);
    });
  
    return data1;
  }

